import { CustomTooltip } from '@/shared/ui/components';
import { t } from 'ttag';
import type { ManagedEditLockProps } from './managedEditLock.types';
import './managedEditLock.scss';

/**
 * Explains why an edit control of a CardioOne-managed study is disabled. While locked, the already-disabled control is wrapped in a span that carries the external-portal tooltip, because a disabled button fires no hover event; otherwise the control renders untouched.
 *
 * @param isLocked - True when the study is managed by CardioOne.
 * @param children - The edit control, which the caller disables when locked.
 * @returns The control, wrapped with the tooltip when locked.
 */
const ManagedEditLock = ({ isLocked, children }: ManagedEditLockProps) =>
  isLocked ? (
    <CustomTooltip
      title={t`This study information can only be edited in the external portal.`}
      placement="bottomRight"
    >
      <span className="managed-edit-lock">{children}</span>
    </CustomTooltip>
  ) : (
    children
  );

export default ManagedEditLock;
